import type { Response, AxiosResponse } from "../../types";
import { painelApi } from "../painelApi";

const PATH_V1_XML = "/v1/xml";

export async function recuperarListaXML(): Promise<AxiosResponse<Response>> {
  return await painelApi.get(`${PATH_V1_XML}/getURL`);
}
